module.exports = __webpack_public_path__ + "static/rosto-aline-frente-413fcd2d1f871ff36c02861946dbf10b.jpg";